var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.$vuetify.breakpoint.mdAndDown
        ? _c(
            "div",
            [
              _c(
                "v-dialog",
                {
                  attrs: {
                    width: "450",
                    transition: "dialog-bottom-transition",
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-label": _vm.$t(
                      "components.deactivatedNotification.title"
                    ),
                  },
                  model: {
                    value: _vm.deactivateVisibility,
                    callback: function ($$v) {
                      _vm.deactivateVisibility = $$v
                    },
                    expression: "deactivateVisibility",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c("v-card-text", [
                        _c("p", { staticClass: "sr-only" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "components.deactivatedNotification.title"
                                )
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("components.deactivatedNotification.info")
                            ) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": "Join Discord",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toDiscord()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.deactivatedNotification.buttons.discord"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                "aria-label": "Visit Facebook Page",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toFbPage()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.deactivatedNotification.buttons.fbPage"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "accent--text",
                              attrs: {
                                "aria-label": "Close Deactivation Notice",
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.deactivateVisibility = 0
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "components.deactivatedNotification.buttons.close"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$vuetify.breakpoint.mdAndDown
        ? _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "", lg12: "" } },
            [
              _c(
                "v-alert",
                {
                  staticClass: "mt-0 mb-0",
                  attrs: {
                    dismissible: "",
                    type: "info",
                    role: "alert",
                    "aria-live": "polite",
                  },
                  model: {
                    value: _vm.deactivateVisibility,
                    callback: function ($$v) {
                      _vm.deactivateVisibility = $$v
                    },
                    expression: "deactivateVisibility",
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t("components.deactivatedNotification.infoDialog")
                      ) +
                      "\n      "
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "primary--text cursor-pointer",
                      attrs: {
                        tabindex: "0",
                        role: "link",
                        "aria-label": "Join Discord",
                      },
                      on: {
                        click: _vm.toDiscord,
                        keypress: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.toDiscord($event)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "components.deactivatedNotification.buttons.discord"
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        " " +
                          _vm.$t("components.deactivatedNotification.or") +
                          " "
                      ) +
                      "\n      "
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "primary--text cursor-pointer",
                      attrs: {
                        tabindex: "0",
                        role: "link",
                        "aria-label": "Visit Facebook Page",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.toFbPage()
                        },
                        keypress: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.toFbPage()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t(
                              "components.deactivatedNotification.buttons.fbPage"
                            )
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }